export const bigTestDataEnergyDay = [
  {
    "ReportTimeStamp": "2026-01-22 00:01:14.376294",
    "ReportDate": "2026-01-21",
    "ReportName": "DayHeatMap",
    "Header": "ReportMessage",
    "CustomerId": "c16084",
    "DeviceId": "os-edge-unit-mini-3",
    "SubReports": {
      "Vantaa": [
        {
          "HwId": "V1",
          "Label": "V Aichelin VKEs kammiouuni 1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 42,
            "11": 40,
            "12": 41,
            "13": 40,
            "14": 4,
            "15": 5,
            "16": 49,
            "17": 35,
            "18": 37,
            "19": 44,
            "20": 70,
            "21": 31,
            "22": 49,
            "23": 39,
            "00": 66,
            "01": 78,
            "02": 93,
            "03": 46,
            "04": 47,
            "05": 46,
            "06": 43,
            "07": 42,
            "08": 41,
            "09": 41
          }
        },
        {
          "HwId": "V10",
          "Label": "V Rübig-plasma",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V11",
          "Label": "V B.M.I-alipaineuuni 52",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 1,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V12",
          "Label": "V B.M.I-alipainepäästöuuni 55",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 3,
            "11": 4,
            "12": 3,
            "13": 21,
            "14": 22,
            "15": 15,
            "16": 11,
            "17": 6,
            "18": 21,
            "19": 12,
            "20": 10,
            "21": 6,
            "22": 4,
            "23": 4,
            "00": 4,
            "01": 3,
            "02": 3,
            "03": 4,
            "04": 3,
            "05": 4,
            "06": 3,
            "07": 4,
            "08": 2,
            "09": 4
          }
        },
        {
          "HwId": "V13",
          "Label": "V Kuoppanitraus",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 35,
            "14": 69,
            "15": 58,
            "16": 60,
            "17": 40,
            "18": 40,
            "19": 34,
            "20": 27,
            "21": 26,
            "22": 25,
            "23": 25,
            "00": 25,
            "01": 25,
            "02": 24,
            "03": 7,
            "04": 2,
            "05": 1,
            "06": 2,
            "07": 2,
            "08": 1,
            "09": 0
          }
        },
        {
          "HwId": "V14",
          "Label": "V B.M.I-jäähdytysjärjestelmä",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V15",
          "Label": "V Päästö/esikuumennusuuni 36",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 11,
            "16": 9,
            "17": 5,
            "18": 3,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V16",
          "Label": "V Pesukone 37",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V17",
          "Label": "V Ipsen T2 38",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 18,
            "11": 19,
            "12": 23,
            "13": 24,
            "14": 21,
            "15": 23,
            "16": 19,
            "17": 18,
            "18": 18,
            "19": 17,
            "20": 17,
            "21": 18,
            "22": 18,
            "23": 17,
            "00": 18,
            "01": 18,
            "02": 18,
            "03": 18,
            "04": 17,
            "05": 18,
            "06": 18,
            "07": 18,
            "08": 15,
            "09": 18
          }
        },
        {
          "HwId": "V18",
          "Label": "V JK1.1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 5,
            "11": 5,
            "12": 5,
            "13": 5,
            "14": 5,
            "15": 5,
            "16": 5,
            "17": 4,
            "18": 6,
            "19": 5,
            "20": 6,
            "21": 5,
            "22": 6,
            "23": 5,
            "00": 5,
            "01": 5,
            "02": 5,
            "03": 5,
            "04": 5,
            "05": 5,
            "06": 5,
            "07": 5,
            "08": 4,
            "09": 6
          }
        },
        {
          "HwId": "V19",
          "Label": "V Etappiallas 39",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V2",
          "Label": "V Aichelin VKEs kammiouuni 2",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 89,
            "11": 51,
            "12": 38,
            "13": 53,
            "14": 37,
            "15": 37,
            "16": 69,
            "17": 75,
            "18": 40,
            "19": 6,
            "20": 51,
            "21": 35,
            "22": 67,
            "23": 97,
            "00": 96,
            "01": 88,
            "02": 53,
            "03": 47,
            "04": 43,
            "05": 41,
            "06": 25,
            "07": 26,
            "08": 36,
            "09": 34
          }
        },
        {
          "HwId": "V20",
          "Label": "V Pesukone 16",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V21",
          "Label": "V Päästöuuni VKHLE 17",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 9,
            "11": 23,
            "12": 9,
            "13": 9,
            "14": 61,
            "15": 24,
            "16": 18,
            "17": 6,
            "18": 70,
            "19": 53,
            "20": 23,
            "21": 22,
            "22": 11,
            "23": 18,
            "00": 10,
            "01": 7,
            "02": 9,
            "03": 8,
            "04": 8,
            "05": 9,
            "06": 25,
            "07": 8,
            "08": 9,
            "09": 10
          }
        },
        {
          "HwId": "V22",
          "Label": "V Alumiiniuuni 25",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V23",
          "Label": "V Päästöuuni VKHLE 26",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V24",
          "Label": "V Päästöuuni VKHLE 27",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 9,
            "11": 37,
            "12": 14,
            "13": 10,
            "14": 5,
            "15": 30,
            "16": 6,
            "17": 11,
            "18": 35,
            "19": 12,
            "20": 9,
            "21": 9,
            "22": 16,
            "23": 6,
            "00": 5,
            "01": 6,
            "02": 6,
            "03": 6,
            "04": 5,
            "05": 6,
            "06": 6,
            "07": 6,
            "08": 5,
            "09": 6
          }
        },
        {
          "HwId": "V25",
          "Label": "V Suojakaasu-uuni 30",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 4,
            "11": 8,
            "12": 4,
            "13": 4,
            "14": 5,
            "15": 4,
            "16": 4,
            "17": 4,
            "18": 4,
            "19": 30,
            "20": 5,
            "21": 5,
            "22": 5,
            "23": 4,
            "00": 22,
            "01": 26,
            "02": 6,
            "03": 6,
            "04": 6,
            "05": 14,
            "06": 22,
            "07": 5,
            "08": 5,
            "09": 18
          }
        },
        {
          "HwId": "V26",
          "Label": "V Työkalupäästöuuni 58",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 14,
            "18": 3,
            "19": 2,
            "20": 1,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V27",
          "Label": "V Tuloilman lämmitys",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V28",
          "Label": "V RK1.1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 5,
            "11": 6,
            "12": 4,
            "13": 3,
            "14": 3,
            "15": 3,
            "16": 3,
            "17": 3,
            "18": 2,
            "19": 3,
            "20": 3,
            "21": 4,
            "22": 3,
            "23": 3,
            "00": 4,
            "01": 4,
            "02": 3,
            "03": 4,
            "04": 3,
            "05": 1,
            "06": 3,
            "07": 4,
            "08": 2,
            "09": 5
          }
        },
        {
          "HwId": "V3",
          "Label": "V Aichelin VKEs kammiouuni 3",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 57,
            "11": 49,
            "12": 51,
            "13": 106,
            "14": 56,
            "15": 52,
            "16": 51,
            "17": 90,
            "18": 108,
            "19": 83,
            "20": 59,
            "21": 57,
            "22": 54,
            "23": 55,
            "00": 49,
            "01": 47,
            "02": 47,
            "03": 91,
            "04": 37,
            "05": 39,
            "06": 69,
            "07": 49,
            "08": 67,
            "09": 76
          }
        },
        {
          "HwId": "V30",
          "Label": "EMpro MA370",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 3.3178366720676422e-9,
            "09": 0
          }
        },
        {
          "HwId": "V4",
          "Label": "V Nitrausuuni KREs 20",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 1,
            "12": 0,
            "13": 1,
            "14": 0,
            "15": 0,
            "16": 1,
            "17": 0,
            "18": 0,
            "19": 1,
            "20": 0,
            "21": 1,
            "22": 0,
            "23": 1,
            "00": 1,
            "01": 1,
            "02": 0,
            "03": 1,
            "04": 1,
            "05": 0,
            "06": 1,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V5",
          "Label": "V Alipainepesukone 21",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 7,
            "11": 6,
            "12": 10,
            "13": 8,
            "14": 9,
            "15": 9,
            "16": 9,
            "17": 16,
            "18": 28,
            "19": 15,
            "20": 7,
            "21": 8,
            "22": 7,
            "23": 7,
            "00": 6,
            "01": 8,
            "02": 9,
            "03": 10,
            "04": 8,
            "05": 12,
            "06": 8,
            "07": 10,
            "08": 8,
            "09": 11
          }
        },
        {
          "HwId": "V6",
          "Label": "V Ipsen Kammiopäästö 53",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V7",
          "Label": "V Avoin jäähdytysjärjestelmä",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 1,
            "11": 0,
            "12": 1,
            "13": 0,
            "14": 1,
            "15": 0,
            "16": 1,
            "17": 1,
            "18": 0,
            "19": 1,
            "20": 1,
            "21": 1,
            "22": 1,
            "23": 1,
            "00": 1,
            "01": 1,
            "02": 1,
            "03": 1,
            "04": 0,
            "05": 1,
            "06": 0,
            "07": 8,
            "08": 7,
            "09": 0
          }
        },
        {
          "HwId": "V8",
          "Label": "V Päästöuuni VKHLE 28",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 48,
            "11": 18,
            "12": 10,
            "13": 10,
            "14": 10,
            "15": 10,
            "16": 36,
            "17": 22,
            "18": 11,
            "19": 10,
            "20": 10,
            "21": 10,
            "22": 11,
            "23": 11,
            "00": 12,
            "01": 10,
            "02": 43,
            "03": 34,
            "04": 12,
            "05": 11,
            "06": 11,
            "07": 12,
            "08": 11,
            "09": 10
          }
        },
        {
          "HwId": "V9",
          "Label": "V Päästöuuni VKHLE 29",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 13,
            "11": 12,
            "12": 9,
            "13": 48,
            "14": 13,
            "15": 12,
            "16": 26,
            "17": 39,
            "18": 12,
            "19": 31,
            "20": 19,
            "21": 11,
            "22": 10,
            "23": 10,
            "00": 44,
            "01": 12,
            "02": 12,
            "03": 4,
            "04": 9,
            "05": 49,
            "06": 19,
            "07": 12,
            "08": 47,
            "09": 26
          }
        }
      ],
      "Tampere": [
        {
          "HwId": "T1",
          "Label": "T C230-päästöuuni P6/1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 51,
            "11": 32,
            "12": 21,
            "13": 17,
            "14": 14,
            "15": 7,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 1,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 144
          }
        },
        {
          "HwId": "T10",
          "Label": "T Codere 230-rekuperaattori 1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 13,
            "11": 12,
            "12": 15,
            "13": 15,
            "14": 13,
            "15": 12,
            "16": 15,
            "17": 15,
            "18": 13,
            "19": 12,
            "20": 14,
            "21": 14,
            "22": 14,
            "23": 11,
            "00": 15,
            "01": 14,
            "02": 11,
            "03": 12,
            "04": 15,
            "05": 14,
            "06": 12,
            "07": 13,
            "08": 14,
            "09": 14
          }
        },
        {
          "HwId": "T12",
          "Label": "T Kuoppanitrausuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 2,
            "11": 1,
            "12": 1,
            "13": 2,
            "14": 1,
            "15": 2,
            "16": 89,
            "17": 88,
            "18": 47,
            "19": 26,
            "20": 18,
            "21": 16,
            "22": 16,
            "23": 16,
            "00": 18,
            "01": 17,
            "02": 15,
            "03": 13,
            "04": 2,
            "05": 3,
            "06": 3,
            "07": 3,
            "08": 4,
            "09": 2
          }
        },
        {
          "HwId": "T13",
          "Label": "T Nitrauksen pesukone",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 13,
            "11": 13,
            "12": 4,
            "13": 4,
            "14": 4,
            "15": 4,
            "16": 3,
            "17": 4,
            "18": 4,
            "19": 4,
            "20": 5,
            "21": 4,
            "22": 4,
            "23": 3,
            "00": 4,
            "01": 4,
            "02": 4,
            "03": 5,
            "04": 11,
            "05": 9,
            "06": 15,
            "07": 9,
            "08": 5,
            "09": 3
          }
        },
        {
          "HwId": "T14",
          "Label": "T Codere 250 päästöuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 31,
            "11": 44,
            "12": 5,
            "13": 1,
            "14": 1,
            "15": 0,
            "16": 1,
            "17": 2,
            "18": 2,
            "19": 16,
            "20": 8,
            "21": 4,
            "22": 2,
            "23": 16,
            "00": 15,
            "01": 3,
            "02": 1,
            "03": 2,
            "04": 0,
            "05": 9,
            "06": 10,
            "07": 8,
            "08": 12,
            "09": 7
          }
        },
        {
          "HwId": "T15",
          "Label": "T Codere 250 pesukone",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 7,
            "11": 4,
            "12": 4,
            "13": 4,
            "14": 4,
            "15": 4,
            "16": 4,
            "17": 3,
            "18": 3,
            "19": 13,
            "20": 4,
            "21": 5,
            "22": 6,
            "23": 4,
            "00": 4,
            "01": 4,
            "02": 3,
            "03": 4,
            "04": 19,
            "05": 7,
            "06": 4,
            "07": 4,
            "08": 15,
            "09": 4
          }
        },
        {
          "HwId": "T16",
          "Label": "T Codere 250 suola-allas",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 18,
            "11": 20,
            "12": 19,
            "13": 19,
            "14": 20,
            "15": 22,
            "16": 88,
            "17": 0,
            "18": 0,
            "19": 4,
            "20": 20,
            "21": 23,
            "22": 20,
            "23": 22,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 19,
            "06": 42,
            "07": 0,
            "08": 0,
            "09": 10
          }
        },
        {
          "HwId": "T17",
          "Label": "T Codere 250 rekuperaattori",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 20,
            "11": 20,
            "12": 19,
            "13": 20,
            "14": 20,
            "15": 20,
            "16": 19,
            "17": 20,
            "18": 20,
            "19": 20,
            "20": 20,
            "21": 20,
            "22": 19,
            "23": 19,
            "00": 19,
            "01": 20,
            "02": 20,
            "03": 20,
            "04": 21,
            "05": 21,
            "06": 21,
            "07": 20,
            "08": 20,
            "09": 21
          }
        },
        {
          "HwId": "T18",
          "Label": "T Codere 250 C10-uuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 42,
            "11": 41,
            "12": 118,
            "13": 47,
            "14": 35,
            "15": 53,
            "16": 51,
            "17": 44,
            "18": 42,
            "19": 42,
            "20": 42,
            "21": 42,
            "22": 42,
            "23": 41,
            "00": 36,
            "01": 99,
            "02": 75,
            "03": 36,
            "04": 37,
            "05": 62,
            "06": 45,
            "07": 43,
            "08": 42,
            "09": 42
          }
        },
        {
          "HwId": "T19",
          "Label": "T Kompressori (pieni)",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "T2",
          "Label": "T C230-öljypesukone LA2H",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 17,
            "11": 16,
            "12": 7,
            "13": 10,
            "14": 11,
            "15": 19,
            "16": 5,
            "17": 3,
            "18": 6,
            "19": 3,
            "20": 2,
            "21": 3,
            "22": 3,
            "23": 2,
            "00": 5,
            "01": 6,
            "02": 4,
            "03": 5,
            "04": 6,
            "05": 5,
            "06": 5,
            "07": 18,
            "08": 15,
            "09": 4
          }
        },
        {
          "HwId": "T20",
          "Label": "T AFC UBT1-päästöuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 18,
            "11": 14,
            "12": 12,
            "13": 16,
            "14": 11,
            "15": 5,
            "16": 5,
            "17": 4,
            "18": 4,
            "19": 21,
            "20": 6,
            "21": 5,
            "22": 6,
            "23": 16,
            "00": 3,
            "01": 2,
            "02": 4,
            "03": 4,
            "04": 4,
            "05": 28,
            "06": 6,
            "07": 5,
            "08": 21,
            "09": 60
          }
        },
        {
          "HwId": "T21",
          "Label": "T Schmetz 1-alipaineuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "T22",
          "Label": "T Carrier (Schmetz)",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 8,
            "11": 7,
            "12": 8,
            "13": 8,
            "14": 21,
            "15": 23,
            "16": 23,
            "17": 17,
            "18": 10,
            "19": 7,
            "20": 8,
            "21": 6,
            "22": 7,
            "23": 8,
            "00": 7,
            "01": 7,
            "02": 7,
            "03": 8,
            "04": 7,
            "05": 7,
            "06": 6,
            "07": 6,
            "08": 11,
            "09": 8
          }
        },
        {
          "HwId": "T23",
          "Label": "T Schmetz-jäähdytys",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 7,
            "11": 7,
            "12": 7,
            "13": 7,
            "14": 18,
            "15": 18,
            "16": 17,
            "17": 7,
            "18": 7,
            "19": 7,
            "20": 7,
            "21": 7,
            "22": 18,
            "23": 18,
            "00": 7,
            "01": 7,
            "02": 17,
            "03": 14,
            "04": 7,
            "05": 7,
            "06": 7,
            "07": 7,
            "08": 11,
            "09": 7
          }
        },
        {
          "HwId": "T24",
          "Label": "T AFC UBQ2-kammiouuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 52,
            "11": 18,
            "12": 16,
            "13": 35,
            "14": 102,
            "15": 109,
            "16": 47,
            "17": 48,
            "18": 165,
            "19": 107,
            "20": 64,
            "21": 60,
            "22": 57,
            "23": 19,
            "00": 53,
            "01": 53,
            "02": 52,
            "03": 52,
            "04": 52,
            "05": 52,
            "06": 51,
            "07": 51,
            "08": 51,
            "09": 51
          }
        },
        {
          "HwId": "T25",
          "Label": "T AFC UBT3-päästöuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 17,
            "11": 14,
            "12": 27,
            "13": 76,
            "14": 17,
            "15": 25,
            "16": 72,
            "17": 26,
            "18": 30,
            "19": 66,
            "20": 34,
            "21": 25,
            "22": 19,
            "23": 17,
            "00": 14,
            "01": 15,
            "02": 14,
            "03": 15,
            "04": 13,
            "05": 62,
            "06": 57,
            "07": 26,
            "08": 71,
            "09": 27
          }
        },
        {
          "HwId": "T26",
          "Label": "T Schmetz 2-alipaineuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 53,
            "11": 69,
            "12": 85,
            "13": 51,
            "14": 97,
            "15": 100,
            "16": 103,
            "17": 20,
            "18": 13,
            "19": 12,
            "20": 12,
            "21": 11,
            "22": 42,
            "23": 44,
            "00": 13,
            "01": 12,
            "02": 41,
            "03": 28,
            "04": 9,
            "05": 118,
            "06": 42,
            "07": 37,
            "08": 33,
            "09": 120
          }
        },
        {
          "HwId": "T27",
          "Label": "T Heattec 2 (Sarlin 2-päästö)",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 5,
            "17": 13,
            "18": 8,
            "19": 7,
            "20": 7,
            "21": 7,
            "22": 7,
            "23": 6,
            "00": 3,
            "01": 4,
            "02": 4,
            "03": 3,
            "04": 2,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "T28",
          "Label": "T AFC UB2T-päästöuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 6,
            "11": 5,
            "12": 6,
            "13": 6,
            "14": 58,
            "15": 61,
            "16": 29,
            "17": 14,
            "18": 3,
            "19": 18,
            "20": 65,
            "21": 54,
            "22": 23,
            "23": 17,
            "00": 5,
            "01": 5,
            "02": 5,
            "03": 6,
            "04": 5,
            "05": 6,
            "06": 5,
            "07": 5,
            "08": 6,
            "09": 5
          }
        },
        {
          "HwId": "T29",
          "Label": "T AFC UBW-pesukone",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "T3",
          "Label": "T C230-hiiletysuuni P10/9",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 46,
            "11": 39,
            "12": 36,
            "13": 50,
            "14": 126,
            "15": 164,
            "16": 198,
            "17": 219,
            "18": 243,
            "19": 224,
            "20": 143,
            "21": 116,
            "22": 103,
            "23": 95,
            "00": 2,
            "01": 12,
            "02": 44,
            "03": 57,
            "04": 62,
            "05": 62,
            "06": 44,
            "07": 108,
            "08": 79,
            "09": 59
          }
        },
        {
          "HwId": "T30",
          "Label": "T Heattec 1 (Sarlin 1-päästö)",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "T31",
          "Label": "T AFC UBQ1-kammiouuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 46,
            "11": 35,
            "12": 162,
            "13": 85,
            "14": 63,
            "15": 58,
            "16": 15,
            "17": 129,
            "18": 134,
            "19": 69,
            "20": 58,
            "21": 55,
            "22": 14,
            "23": 76,
            "00": 14,
            "01": 74,
            "02": 62,
            "03": 58,
            "04": 55,
            "05": 96,
            "06": 50,
            "07": 127,
            "08": 155,
            "09": 75
          }
        },
        {
          "HwId": "T32",
          "Label": "T Kompressori (suuri)",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 26,
            "11": 26,
            "12": 27,
            "13": 27,
            "14": 30,
            "15": 30,
            "16": 29,
            "17": 28,
            "18": 30,
            "19": 25,
            "20": 22,
            "21": 23,
            "22": 23,
            "23": 23,
            "00": 23,
            "01": 22,
            "02": 22,
            "03": 22,
            "04": 26,
            "05": 27,
            "06": 27,
            "07": 30,
            "08": 28,
            "09": 29
          }
        },
        {
          "HwId": "T33",
          "Label": "T Heattec 3",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 26,
            "11": 25,
            "12": 27,
            "13": 27,
            "14": 30,
            "15": 30,
            "16": 29,
            "17": 28,
            "18": 30,
            "19": 25,
            "20": 22,
            "21": 23,
            "22": 23,
            "23": 23,
            "00": 23,
            "01": 22,
            "02": 22,
            "03": 22,
            "04": 26,
            "05": 27,
            "06": 27,
            "07": 30,
            "08": 28,
            "09": 29
          }
        },
        {
          "HwId": "T34",
          "Label": "T Aicheling-päästö",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 26,
            "11": 25,
            "12": 27,
            "13": 27,
            "14": 30,
            "15": 30,
            "16": 29,
            "17": 28,
            "18": 29,
            "19": 25,
            "20": 22,
            "21": 23,
            "22": 23,
            "23": 23,
            "00": 23,
            "01": 22,
            "02": 22,
            "03": 22,
            "04": 26,
            "05": 27,
            "06": 27,
            "07": 30,
            "08": 28,
            "09": 29
          }
        },
        {
          "HwId": "T4",
          "Label": "T C230-öljyallas H1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 41,
            "11": 54,
            "12": 42,
            "13": 31,
            "14": 2,
            "15": 3,
            "16": 2,
            "17": 3,
            "18": 2,
            "19": 3,
            "20": 3,
            "21": 3,
            "22": 3,
            "23": 2,
            "00": 3,
            "01": 3,
            "02": 3,
            "03": 3,
            "04": 32,
            "05": 54,
            "06": 42,
            "07": 53,
            "08": 53,
            "09": 53
          }
        },
        {
          "HwId": "T5",
          "Label": "T C230-hiiletysuuni P10/10",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 33,
            "11": 2,
            "12": 2,
            "13": 60,
            "14": 65,
            "15": 21,
            "16": 19,
            "17": 32,
            "18": 193,
            "19": 301,
            "20": 179,
            "21": 94,
            "22": 83,
            "23": 74,
            "00": 71,
            "01": 72,
            "02": 71,
            "03": 67,
            "04": 83,
            "05": 256,
            "06": 235,
            "07": 106,
            "08": 78,
            "09": 72
          }
        },
        {
          "HwId": "T6",
          "Label": "T C230-suola-allas S4",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 54,
            "11": 68,
            "12": 67,
            "13": 75,
            "14": 55,
            "15": 51,
            "16": 51,
            "17": 54,
            "18": 55,
            "19": 52,
            "20": 50,
            "21": 53,
            "22": 51,
            "23": 54,
            "00": 49,
            "01": 55,
            "02": 48,
            "03": 48,
            "04": 57,
            "05": 52,
            "06": 46,
            "07": 54,
            "08": 50,
            "09": 54
          }
        },
        {
          "HwId": "T7",
          "Label": "T C230-suolapesukone LA3S",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 40,
            "11": 36,
            "12": 39,
            "13": 43,
            "14": 40,
            "15": 35,
            "16": 41,
            "17": 40,
            "18": 42,
            "19": 34,
            "20": 39,
            "21": 39,
            "22": 41,
            "23": 34,
            "00": 40,
            "01": 39,
            "02": 38,
            "03": 29,
            "04": 49,
            "05": 45,
            "06": 42,
            "07": 34,
            "08": 41,
            "09": 42
          }
        },
        {
          "HwId": "T8",
          "Label": "T C230-päästöuuni P6/7",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 17,
            "11": 242,
            "12": 100,
            "13": 24,
            "14": 0,
            "15": 45,
            "16": 14,
            "17": 8,
            "18": 0,
            "19": 67,
            "20": 18,
            "21": 12,
            "22": 10,
            "23": 11,
            "00": 174,
            "01": 53,
            "02": 35,
            "03": 30,
            "04": 9,
            "05": 188,
            "06": 137,
            "07": 189,
            "08": 49,
            "09": 30
          }
        },
        {
          "HwId": "T9",
          "Label": "T Vesilaitos",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 10,
            "11": 10,
            "12": 10,
            "13": 11,
            "14": 10,
            "15": 10,
            "16": 11,
            "17": 10,
            "18": 10,
            "19": 11,
            "20": 11,
            "21": 11,
            "22": 10,
            "23": 10,
            "00": 11,
            "01": 11,
            "02": 11,
            "03": 11,
            "04": 11,
            "05": 10,
            "06": 11,
            "07": 11,
            "08": 10,
            "09": 11
          }
        }
      ],
      "Pieksämäki": [
        {
          "HwId": "P1",
          "Label": "P Ipsen T13",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 49,
            "11": 16,
            "12": 64,
            "13": 89,
            "14": 58,
            "15": 53,
            "16": 52,
            "17": 48,
            "18": 62,
            "19": 102,
            "20": 53,
            "21": 52,
            "22": 50,
            "23": 44,
            "00": 29,
            "01": 30,
            "02": 30,
            "03": 30,
            "04": 30,
            "05": 81,
            "06": 73,
            "07": 57,
            "08": 129,
            "09": 68
          }
        },
        {
          "HwId": "P10",
          "Label": "P Kaminski",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 1,
            "13": 0,
            "14": 1,
            "15": 0,
            "16": 1,
            "17": 0,
            "18": 0,
            "19": 1,
            "20": 0,
            "21": 1,
            "22": 0,
            "23": 1,
            "00": 0,
            "01": 0,
            "02": 1,
            "03": 0,
            "04": 1,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 1
          }
        },
        {
          "HwId": "P11",
          "Label": "P Sarlin-kammionitrausuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "P12",
          "Label": "P Nitrauksen pesukone",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 2,
            "11": 21,
            "12": 18,
            "13": 8,
            "14": 14,
            "15": 22,
            "16": 4,
            "17": 24,
            "18": 27,
            "19": 16,
            "20": 13,
            "21": 10,
            "22": 10,
            "23": 20,
            "00": 19,
            "01": 8,
            "02": 20,
            "03": 7,
            "04": 16,
            "05": 43,
            "06": 26,
            "07": 1,
            "08": 19,
            "09": 25
          }
        },
        {
          "HwId": "P13",
          "Label": "P Borel-kuoppauuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 34,
            "11": 38,
            "12": 60,
            "13": 115,
            "14": 40,
            "15": 30,
            "16": 23,
            "17": 1,
            "18": 1,
            "19": 1,
            "20": 1,
            "21": 1,
            "22": 1,
            "23": 1,
            "00": 1,
            "01": 1,
            "02": 29,
            "03": 116,
            "04": 102,
            "05": 90,
            "06": 37,
            "07": 36,
            "08": 105,
            "09": 80
          }
        },
        {
          "HwId": "P14",
          "Label": "P Kuoppanitrausuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 12,
            "16": 34,
            "17": 40,
            "18": 14,
            "19": 45,
            "20": 48,
            "21": 26,
            "22": 23,
            "23": 22,
            "00": 34,
            "01": 21,
            "02": 23,
            "03": 20,
            "04": 5,
            "05": 10,
            "06": 16,
            "07": 5,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "P15",
          "Label": "P Iso kuoppapäästöuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 7,
            "11": 1,
            "12": 8,
            "13": 15,
            "14": 8,
            "15": 6,
            "16": 1,
            "17": 31,
            "18": 10,
            "19": 7,
            "20": 3,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 27,
            "09": 10
          }
        },
        {
          "HwId": "P16",
          "Label": "P Päästöuuni 'Iso B'",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 23,
            "11": 21,
            "12": 19,
            "13": 19,
            "14": 18,
            "15": 4,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 30,
            "07": 53,
            "08": 50,
            "09": 29
          }
        },
        {
          "HwId": "P18",
          "Label": "P Ufo",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "P2",
          "Label": "P Ipsen T17",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 49,
            "11": 49,
            "12": 48,
            "13": 48,
            "14": 48,
            "15": 47,
            "16": 47,
            "17": 47,
            "18": 47,
            "19": 47,
            "20": 10,
            "21": 0,
            "22": 29,
            "23": 56,
            "00": 48,
            "01": 46,
            "02": 18,
            "03": 11,
            "04": 124,
            "05": 134,
            "06": 90,
            "07": 57,
            "08": 52,
            "09": 50
          }
        },
        {
          "HwId": "P20",
          "Label": "P Ipsen T17_1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 45,
            "11": 35,
            "12": 102,
            "13": 71,
            "14": 40,
            "15": 82,
            "16": 63,
            "17": 42,
            "18": 90,
            "19": 41,
            "20": 43,
            "21": 82,
            "22": 40,
            "23": 125,
            "00": 39,
            "01": 48,
            "02": 39,
            "03": 112,
            "04": 37,
            "05": 51,
            "06": 65,
            "07": 84,
            "08": 37,
            "09": 47
          }
        },
        {
          "HwId": "P3",
          "Label": "P Heattec 1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 8,
            "11": 8,
            "12": 54,
            "13": 61,
            "14": 22,
            "15": 21,
            "16": 19,
            "17": 45,
            "18": 54,
            "19": 20,
            "20": 19,
            "21": 14,
            "22": 18,
            "23": 6,
            "00": 8,
            "01": 8,
            "02": 8,
            "03": 8,
            "04": 7,
            "05": 17,
            "06": 11,
            "07": 8,
            "08": 8,
            "09": 8
          }
        },
        {
          "HwId": "P4",
          "Label": "P Heattec 2",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 19,
            "11": 21,
            "12": 19,
            "13": 20,
            "14": 27,
            "15": 51,
            "16": 19,
            "17": 19,
            "18": 20,
            "19": 45,
            "20": 21,
            "21": 62,
            "22": 51,
            "23": 29,
            "00": 56,
            "01": 56,
            "02": 31,
            "03": 23,
            "04": 61,
            "05": 33,
            "06": 20,
            "07": 20,
            "08": 19,
            "09": 20
          }
        },
        {
          "HwId": "P5",
          "Label": "P Heattec 3",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 40,
            "11": 13,
            "12": 13,
            "13": 13,
            "14": 43,
            "15": 15,
            "16": 30,
            "17": 25,
            "18": 14,
            "19": 13,
            "20": 43,
            "21": 35,
            "22": 14,
            "23": 48,
            "00": 33,
            "01": 12,
            "02": 12,
            "03": 42,
            "04": 39,
            "05": 13,
            "06": 24,
            "07": 40,
            "08": 13,
            "09": 13
          }
        },
        {
          "HwId": "P6",
          "Label": "P Heattec 4",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 19,
            "11": 20,
            "12": 7,
            "13": 5,
            "14": 18,
            "15": 8,
            "16": 7,
            "17": 8,
            "18": 12,
            "19": 9,
            "20": 8,
            "21": 34,
            "22": 7,
            "23": 9,
            "00": 9,
            "01": 8,
            "02": 8,
            "03": 20,
            "04": 9,
            "05": 8,
            "06": 8,
            "07": 19,
            "08": 63,
            "09": 41
          }
        },
        {
          "HwId": "P7",
          "Label": "P Automaattilinjan pesukone",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 3,
            "11": 17,
            "12": 9,
            "13": 22,
            "14": 21,
            "15": 11,
            "16": 12,
            "17": 15,
            "18": 12,
            "19": 23,
            "20": 9,
            "21": 13,
            "22": 12,
            "23": 8,
            "00": 9,
            "01": 8,
            "02": 8,
            "03": 16,
            "04": 6,
            "05": 19,
            "06": 13,
            "07": 18,
            "08": 8,
            "09": 10
          }
        },
        {
          "HwId": "P8",
          "Label": "P Kompressori",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 1,
            "11": 0,
            "12": 1,
            "13": 1,
            "14": 0,
            "15": 1,
            "16": 1,
            "17": 0,
            "18": 1,
            "19": 1,
            "20": 0,
            "21": 1,
            "22": 1,
            "23": 1,
            "00": 1,
            "01": 0,
            "02": 1,
            "03": 1,
            "04": 0,
            "05": 1,
            "06": 1,
            "07": 0,
            "08": 1,
            "09": 1
          }
        },
        {
          "HwId": "P9",
          "Label": "P Jäähdytysjärjestelmä",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 8,
            "11": 7,
            "12": 8,
            "13": 6,
            "14": 7,
            "15": 9,
            "16": 6,
            "17": 9,
            "18": 8,
            "19": 6,
            "20": 8,
            "21": 6,
            "22": 7,
            "23": 11,
            "00": 6,
            "01": 8,
            "02": 7,
            "03": 6,
            "04": 7,
            "05": 9,
            "06": 8,
            "07": 6,
            "08": 6,
            "09": 6
          }
        }
      ]
    }
  },
  {
    "ReportTimeStamp": "2026-01-21 00:01:13.334131",
    "ReportDate": "2026-01-20",
    "ReportName": "DayHeatMap",
    "Header": "ReportMessage",
    "CustomerId": "c16084",
    "DeviceId": "os-edge-unit-mini-3",
    "SubReports": {
      "Vantaa": [
        {
          "HwId": "V1",
          "Label": "V Aichelin VKEs kammiouuni 1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 49,
            "11": 32,
            "12": 34,
            "13": 59,
            "14": 38,
            "15": 81,
            "16": 71,
            "17": 38,
            "18": 40,
            "19": 38,
            "20": 34,
            "21": 101,
            "22": 51,
            "23": 35,
            "00": 35,
            "01": 102,
            "02": 55,
            "03": 31,
            "04": 57,
            "05": 35,
            "06": 43,
            "07": 37,
            "08": 34,
            "09": 116
          }
        },
        {
          "HwId": "V10",
          "Label": "V Rübig-plasma",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V11",
          "Label": "V B.M.I-alipaineuuni 52",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 1,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V12",
          "Label": "V B.M.I-alipainepäästöuuni 55",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 3,
            "11": 4,
            "12": 3,
            "13": 4,
            "14": 21,
            "15": 11,
            "16": 10,
            "17": 6,
            "18": 19,
            "19": 11,
            "20": 11,
            "21": 6,
            "22": 4,
            "23": 3,
            "00": 5,
            "01": 3,
            "02": 4,
            "03": 3,
            "04": 3,
            "05": 4,
            "06": 3,
            "07": 4,
            "08": 3,
            "09": 4
          }
        },
        {
          "HwId": "V13",
          "Label": "V Kuoppanitraus",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 1,
            "11": 2,
            "12": 2,
            "13": 25,
            "14": 69,
            "15": 69,
            "16": 50,
            "17": 57,
            "18": 41,
            "19": 39,
            "20": 31,
            "21": 27,
            "22": 27,
            "23": 27,
            "00": 2,
            "01": 2,
            "02": 2,
            "03": 2,
            "04": 2,
            "05": 2,
            "06": 2,
            "07": 2,
            "08": 2,
            "09": 2
          }
        },
        {
          "HwId": "V14",
          "Label": "V B.M.I-jäähdytysjärjestelmä",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V15",
          "Label": "V Päästö/esikuumennusuuni 36",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 18,
            "11": 5,
            "12": 5,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 1
          }
        },
        {
          "HwId": "V16",
          "Label": "V Pesukone 37",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V17",
          "Label": "V Ipsen T2 38",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 21,
            "11": 21,
            "12": 19,
            "13": 18,
            "14": 18,
            "15": 18,
            "16": 18,
            "17": 18,
            "18": 18,
            "19": 18,
            "20": 18,
            "21": 18,
            "22": 18,
            "23": 17,
            "00": 17,
            "01": 18,
            "02": 17,
            "03": 15,
            "04": 17,
            "05": 18,
            "06": 17,
            "07": 24,
            "08": 18,
            "09": 24
          }
        },
        {
          "HwId": "V18",
          "Label": "V JK1.1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 5,
            "11": 5,
            "12": 6,
            "13": 5,
            "14": 5,
            "15": 5,
            "16": 6,
            "17": 5,
            "18": 5,
            "19": 6,
            "20": 5,
            "21": 5,
            "22": 6,
            "23": 5,
            "00": 5,
            "01": 6,
            "02": 5,
            "03": 4,
            "04": 6,
            "05": 5,
            "06": 5,
            "07": 5,
            "08": 6,
            "09": 5
          }
        },
        {
          "HwId": "V19",
          "Label": "V Etappiallas 39",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V2",
          "Label": "V Aichelin VKEs kammiouuni 2",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 40,
            "11": 90,
            "12": 97,
            "13": 65,
            "14": 47,
            "15": 47,
            "16": 42,
            "17": 31,
            "18": 32,
            "19": 26,
            "20": 36,
            "21": 35,
            "22": 36,
            "23": 35,
            "00": 62,
            "01": 38,
            "02": 34,
            "03": 50,
            "04": 39,
            "05": 38,
            "06": 39,
            "07": 40,
            "08": 38,
            "09": 38
          }
        },
        {
          "HwId": "V27",
          "Label": "V Tuloilman lämmitys",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V28",
          "Label": "V RK1.1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 6,
            "11": 4,
            "12": 4,
            "13": 4,
            "14": 3,
            "15": 2,
            "16": 4,
            "17": 3,
            "18": 5,
            "19": 4,
            "20": 4,
            "21": 4,
            "22": 3,
            "23": 4,
            "00": 4,
            "01": 3,
            "02": 3,
            "03": 4,
            "04": 3,
            "05": 5,
            "06": 5,
            "07": 5,
            "08": 5,
            "09": 4
          }
        },
        {
          "HwId": "V3",
          "Label": "V Aichelin VKEs kammiouuni 3",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 43,
            "11": 49,
            "12": 72,
            "13": 126,
            "14": 58,
            "15": 53,
            "16": 54,
            "17": 29,
            "18": 37,
            "19": 107,
            "20": 53,
            "21": 33,
            "22": 43,
            "23": 46,
            "00": 46,
            "01": 48,
            "02": 51,
            "03": 44,
            "04": 48,
            "05": 48,
            "06": 48,
            "07": 45,
            "08": 44,
            "09": 47
          }
        },
        {
          "HwId": "V30",
          "Label": "EMpro MA370",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V4",
          "Label": "V Nitrausuuni KREs 20",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 99,
            "11": 63,
            "12": 89,
            "13": 78,
            "14": 68,
            "15": 58,
            "16": 58,
            "17": 54,
            "18": 61,
            "19": 45,
            "20": 41,
            "21": 25,
            "22": 16,
            "23": 1,
            "00": 49,
            "01": 24,
            "02": 23,
            "03": 4,
            "04": 1,
            "05": 0,
            "06": 1,
            "07": 0,
            "08": 0,
            "09": 24
          }
        },
        {
          "HwId": "V5",
          "Label": "V Alipainepesukone 21",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 9,
            "11": 10,
            "12": 23,
            "13": 18,
            "14": 10,
            "15": 6,
            "16": 9,
            "17": 11,
            "18": 8,
            "19": 7,
            "20": 7,
            "21": 7,
            "22": 10,
            "23": 7,
            "00": 8,
            "01": 10,
            "02": 12,
            "03": 7,
            "04": 11,
            "05": 8,
            "06": 9,
            "07": 11,
            "08": 25,
            "09": 25
          }
        },
        {
          "HwId": "V6",
          "Label": "V Ipsen Kammiopäästö 53",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V7",
          "Label": "V Avoin jäähdytysjärjestelmä",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 1,
            "11": 0,
            "12": 1,
            "13": 0,
            "14": 1,
            "15": 1,
            "16": 1,
            "17": 1,
            "18": 0,
            "19": 1,
            "20": 1,
            "21": 1,
            "22": 1,
            "23": 1,
            "00": 1,
            "01": 1,
            "02": 1,
            "03": 0,
            "04": 1,
            "05": 1,
            "06": 0,
            "07": 1,
            "08": 0,
            "09": 1
          }
        },
        {
          "HwId": "V8",
          "Label": "V Päästöuuni VKHLE 28",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 18,
            "11": 31,
            "12": 12,
            "13": 11,
            "14": 12,
            "15": 12,
            "16": 12,
            "17": 12,
            "18": 28,
            "19": 24,
            "20": 11,
            "21": 9,
            "22": 10,
            "23": 10,
            "00": 10,
            "01": 5,
            "02": 10,
            "03": 8,
            "04": 10,
            "05": 10,
            "06": 10,
            "07": 24,
            "08": 60,
            "09": 12
          }
        },
        {
          "HwId": "V9",
          "Label": "V Päästöuuni VKHLE 29",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 13,
            "11": 12,
            "12": 7,
            "13": 61,
            "14": 13,
            "15": 54,
            "16": 29,
            "17": 13,
            "18": 12,
            "19": 11,
            "20": 17,
            "21": 55,
            "22": 12,
            "23": 17,
            "00": 9,
            "01": 10,
            "02": 10,
            "03": 9,
            "04": 10,
            "05": 13,
            "06": 70,
            "07": 27,
            "08": 19,
            "09": 58
          }
        },
        {
          "HwId": "V20",
          "Label": "V Pesukone 16",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V21",
          "Label": "V Päästöuuni VKHLE 17",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 22,
            "11": 17,
            "12": 5,
            "13": 7,
            "14": 6,
            "15": 8,
            "16": 8,
            "17": 8,
            "18": 20,
            "19": 13,
            "20": 9,
            "21": 7,
            "22": 16,
            "23": 11,
            "07": 43,
            "08": 64,
            "09": 28
          }
        },
        {
          "HwId": "V22",
          "Label": "V Alumiiniuuni 25",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V23",
          "Label": "V Päästöuuni VKHLE 26",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V24",
          "Label": "V Päästöuuni VKHLE 27",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 6,
            "11": 6,
            "12": 6,
            "13": 5,
            "14": 6,
            "15": 6,
            "16": 6,
            "17": 6,
            "18": 6,
            "19": 5,
            "20": 6,
            "21": 6,
            "22": 6,
            "23": 6,
            "07": 6,
            "08": 6,
            "09": 6
          }
        },
        {
          "HwId": "V25",
          "Label": "V Suojakaasu-uuni 30",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 5,
            "11": 6,
            "12": 5,
            "13": 11,
            "14": 30,
            "15": 6,
            "16": 3,
            "17": 2,
            "18": 2,
            "19": 2,
            "20": 2,
            "21": 23,
            "22": 9,
            "23": 6,
            "07": 3,
            "08": 41,
            "09": 10
          }
        },
        {
          "HwId": "V26",
          "Label": "V Työkalupäästöuuni 58",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 16,
            "14": 3,
            "15": 1,
            "16": 1,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        }
      ],
      "Tampere": [
        {
          "HwId": "T14",
          "Label": "T Codere 250 päästöuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 2,
            "11": 3,
            "12": 3,
            "13": 2,
            "14": 3,
            "15": 3,
            "16": 2,
            "17": 3,
            "18": 3,
            "19": 38,
            "20": 41,
            "21": 49,
            "22": 21,
            "23": 16,
            "00": 1,
            "01": 0,
            "02": 1,
            "03": 1,
            "04": 2,
            "05": 2,
            "06": 3,
            "07": 2,
            "08": 2,
            "09": 3
          }
        },
        {
          "HwId": "T15",
          "Label": "T Codere 250 pesukone",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 8,
            "11": 4,
            "12": 3,
            "13": 7,
            "14": 4,
            "15": 4,
            "16": 4,
            "17": 4,
            "18": 4,
            "19": 4,
            "20": 3,
            "21": 4,
            "22": 3,
            "23": 4,
            "00": 3,
            "01": 4,
            "02": 3,
            "03": 3,
            "04": 12,
            "05": 4,
            "06": 6,
            "07": 4,
            "08": 4,
            "09": 7
          }
        },
        {
          "HwId": "T16",
          "Label": "T Codere 250 suola-allas",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 69,
            "01": 57,
            "02": 95,
            "03": 21,
            "04": 77,
            "05": 66,
            "06": 71,
            "07": 25,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "T17",
          "Label": "T Codere 250 rekuperaattori",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 21,
            "11": 20,
            "12": 20,
            "13": 20,
            "14": 20,
            "15": 19,
            "16": 19,
            "17": 20,
            "18": 19,
            "19": 19,
            "20": 18,
            "21": 19,
            "22": 19,
            "23": 19,
            "00": 20,
            "01": 20,
            "02": 21,
            "03": 21,
            "04": 21,
            "05": 21,
            "06": 20,
            "07": 21,
            "08": 20,
            "09": 20
          }
        },
        {
          "HwId": "T18",
          "Label": "T Codere 250 C10-uuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 26,
            "11": 39,
            "12": 40,
            "13": 41,
            "14": 41,
            "15": 42,
            "16": 42,
            "17": 41,
            "18": 41,
            "19": 42,
            "20": 42,
            "21": 99,
            "22": 66,
            "23": 35,
            "00": 37,
            "01": 38,
            "02": 39,
            "03": 53,
            "04": 43,
            "05": 42,
            "06": 61,
            "07": 49,
            "08": 48,
            "09": 47
          }
        },
        {
          "HwId": "T19",
          "Label": "T Kompressori (pieni)",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "T20",
          "Label": "T AFC UBT1-päästöuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 54,
            "11": 17,
            "12": 13,
            "13": 11,
            "14": 6,
            "15": 6,
            "16": 5,
            "17": 5,
            "18": 22,
            "19": 63,
            "20": 26,
            "21": 14,
            "22": 13,
            "23": 4,
            "00": 3,
            "01": 3,
            "02": 4,
            "03": 4,
            "04": 4,
            "05": 25,
            "06": 6,
            "07": 5,
            "08": 5,
            "09": 29
          }
        },
        {
          "HwId": "T21",
          "Label": "T Schmetz 1-alipaineuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "T22",
          "Label": "T Carrier (Schmetz)",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 7,
            "11": 7,
            "12": 8,
            "13": 7,
            "14": 8,
            "15": 11,
            "16": 23,
            "17": 23,
            "18": 21,
            "19": 15,
            "20": 8,
            "21": 11,
            "22": 11,
            "23": 8,
            "00": 8,
            "01": 6,
            "02": 8,
            "03": 8,
            "04": 7,
            "05": 5,
            "06": 6,
            "07": 6,
            "08": 13,
            "09": 8
          }
        },
        {
          "HwId": "T23",
          "Label": "T Schmetz-jäähdytys",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 7,
            "11": 7,
            "12": 7,
            "13": 7,
            "14": 7,
            "15": 10,
            "16": 18,
            "17": 12,
            "18": 7,
            "19": 7,
            "20": 7,
            "21": 18,
            "22": 12,
            "23": 8,
            "00": 7,
            "01": 11,
            "02": 19,
            "03": 8,
            "04": 7,
            "05": 7,
            "06": 7,
            "07": 8,
            "08": 14,
            "09": 7
          }
        },
        {
          "HwId": "T24",
          "Label": "T AFC UBQ2-kammiouuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 96,
            "11": 55,
            "12": 46,
            "13": 135,
            "14": 101,
            "15": 71,
            "16": 59,
            "17": 56,
            "18": 55,
            "19": 55,
            "20": 54,
            "21": 53,
            "22": 52,
            "23": 53,
            "00": 55,
            "01": 53,
            "02": 53,
            "03": 53,
            "04": 53,
            "05": 38,
            "06": 7,
            "07": 26,
            "08": 39,
            "09": 148
          }
        },
        {
          "HwId": "T25",
          "Label": "T AFC UBT3-päästöuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 36,
            "11": 23,
            "12": 20,
            "13": 26,
            "14": 82,
            "15": 29,
            "16": 16,
            "17": 33,
            "18": 50,
            "19": 16,
            "20": 16,
            "21": 14,
            "22": 15,
            "23": 15,
            "00": 15,
            "01": 14,
            "02": 14,
            "03": 15,
            "04": 11,
            "05": 71,
            "06": 53,
            "07": 24,
            "08": 17,
            "09": 39
          }
        },
        {
          "HwId": "T26",
          "Label": "T Schmetz 2-alipaineuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 102,
            "11": 60,
            "12": 107,
            "13": 58,
            "14": 113,
            "15": 77,
            "16": 98,
            "17": 74,
            "18": 16,
            "19": 13,
            "20": 12,
            "21": 43,
            "22": 54,
            "23": 18,
            "00": 13,
            "01": 24,
            "02": 43,
            "03": 6,
            "04": 14,
            "05": 114,
            "06": 41,
            "07": 39,
            "08": 26,
            "09": 124
          }
        },
        {
          "HwId": "T27",
          "Label": "T Heattec 2 (Sarlin 2-päästö)",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 22,
            "16": 25,
            "17": 23,
            "18": 11,
            "19": 10,
            "20": 9,
            "21": 3,
            "22": 3,
            "23": 4,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "T28",
          "Label": "T AFC UB2T-päästöuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 3,
            "11": 16,
            "12": 65,
            "13": 37,
            "14": 14,
            "15": 9,
            "16": 3,
            "17": 5,
            "18": 5,
            "19": 5,
            "20": 5,
            "21": 5,
            "22": 6,
            "23": 5,
            "00": 5,
            "01": 5,
            "02": 6,
            "03": 5,
            "04": 5,
            "05": 6,
            "06": 5,
            "07": 48,
            "08": 45,
            "09": 15
          }
        },
        {
          "HwId": "T29",
          "Label": "T AFC UBW-pesukone",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "T30",
          "Label": "T Heattec 1 (Sarlin 1-päästö)",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 11,
            "12": 6,
            "13": 6,
            "14": 5,
            "15": 5,
            "16": 4,
            "17": 5,
            "18": 1,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "T31",
          "Label": "T AFC UBQ1-kammiouuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 60,
            "11": 59,
            "12": 103,
            "13": 55,
            "14": 68,
            "15": 124,
            "16": 56,
            "17": 133,
            "18": 153,
            "19": 71,
            "20": 62,
            "21": 59,
            "22": 58,
            "23": 40,
            "00": 57,
            "01": 20,
            "02": 70,
            "03": 62,
            "04": 66,
            "05": 154,
            "06": 71,
            "07": 58,
            "08": 17,
            "09": 98
          }
        },
        {
          "HwId": "T32",
          "Label": "T Kompressori (suuri)",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 29,
            "11": 28,
            "12": 29,
            "13": 29,
            "14": 29,
            "15": 28,
            "16": 28,
            "17": 29,
            "18": 26,
            "19": 23,
            "20": 23,
            "21": 21,
            "22": 23,
            "23": 23,
            "00": 23,
            "01": 23,
            "02": 23,
            "03": 23,
            "04": 26,
            "05": 28,
            "06": 29,
            "07": 28,
            "08": 29,
            "09": 30
          }
        },
        {
          "HwId": "T33",
          "Label": "T Heattec 3",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 29,
            "11": 28,
            "12": 29,
            "13": 29,
            "14": 29,
            "15": 28,
            "16": 28,
            "17": 29,
            "18": 26,
            "19": 23,
            "20": 23,
            "21": 21,
            "22": 23,
            "23": 23,
            "00": 23,
            "01": 23,
            "02": 23,
            "03": 23,
            "04": 26,
            "05": 28,
            "06": 29,
            "07": 28,
            "08": 29,
            "09": 30
          }
        },
        {
          "HwId": "T34",
          "Label": "T Aicheling-päästö",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 29,
            "11": 28,
            "12": 29,
            "13": 29,
            "14": 29,
            "15": 28,
            "16": 28,
            "17": 29,
            "18": 26,
            "19": 23,
            "20": 23,
            "21": 21,
            "22": 23,
            "23": 23,
            "00": 23,
            "01": 23,
            "02": 23,
            "03": 23,
            "04": 26,
            "05": 28,
            "06": 29,
            "07": 28,
            "08": 29,
            "09": 30
          }
        },
        {
          "HwId": "T1",
          "Label": "T C230-päästöuuni P6/1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 1,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "T10",
          "Label": "T Codere 230-rekuperaattori 1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 11,
            "11": 14,
            "12": 15,
            "13": 14,
            "14": 11,
            "15": 15,
            "16": 14,
            "17": 15,
            "18": 11,
            "19": 14,
            "20": 14,
            "21": 15,
            "22": 11,
            "23": 13,
            "07": 8,
            "08": 15,
            "09": 14
          }
        },
        {
          "HwId": "T12",
          "Label": "T Kuoppanitrausuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 1,
            "11": 1,
            "12": 2,
            "13": 1,
            "14": 1,
            "15": 2,
            "16": 1,
            "17": 2,
            "18": 23,
            "19": 90,
            "20": 34,
            "21": 14,
            "22": 58,
            "23": 22,
            "07": 2,
            "08": 3,
            "09": 3
          }
        },
        {
          "HwId": "T13",
          "Label": "T Nitrauksen pesukone",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 4,
            "11": 5,
            "12": 3,
            "13": 5,
            "14": 4,
            "15": 4,
            "16": 3,
            "17": 4,
            "18": 4,
            "19": 5,
            "20": 3,
            "21": 4,
            "22": 5,
            "23": 4,
            "07": 2,
            "08": 3,
            "09": 5
          }
        },
        {
          "HwId": "T2",
          "Label": "T C230-öljypesukone LA2H",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 7,
            "11": 5,
            "12": 5,
            "13": 7,
            "14": 4,
            "15": 6,
            "16": 6,
            "17": 5,
            "18": 6,
            "19": 5,
            "20": 5,
            "21": 5,
            "22": 5,
            "23": 5,
            "07": 12,
            "08": 12,
            "09": 6
          }
        },
        {
          "HwId": "T3",
          "Label": "T C230-hiiletysuuni P10/9",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 81,
            "11": 79,
            "12": 77,
            "13": 77,
            "14": 77,
            "15": 76,
            "16": 76,
            "17": 75,
            "18": 75,
            "19": 75,
            "20": 75,
            "21": 75,
            "22": 75,
            "23": 27,
            "07": 45,
            "08": 80,
            "09": 80
          }
        },
        {
          "HwId": "T4",
          "Label": "T C230-öljyallas H1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 3,
            "11": 3,
            "12": 2,
            "13": 3,
            "14": 3,
            "15": 3,
            "16": 2,
            "17": 3,
            "18": 3,
            "19": 3,
            "20": 3,
            "21": 4,
            "22": 3,
            "23": 3,
            "07": 1,
            "08": 3,
            "09": 2
          }
        },
        {
          "HwId": "T5",
          "Label": "T C230-hiiletysuuni P10/10",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 56,
            "11": 54,
            "12": 45,
            "13": 4,
            "14": 2,
            "15": 131,
            "16": 50,
            "17": 169,
            "18": 260,
            "19": 188,
            "20": 97,
            "21": 85,
            "22": 76,
            "23": 77,
            "07": 1,
            "08": 2,
            "09": 3
          }
        },
        {
          "HwId": "T6",
          "Label": "T C230-suola-allas S4",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 49,
            "11": 52,
            "12": 52,
            "13": 61,
            "14": 65,
            "15": 62,
            "16": 52,
            "17": 50,
            "18": 50,
            "19": 52,
            "20": 50,
            "21": 52,
            "22": 51,
            "23": 49,
            "07": 28,
            "08": 59,
            "09": 46
          }
        },
        {
          "HwId": "T7",
          "Label": "T C230-suolapesukone LA3S",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 30,
            "11": 51,
            "12": 43,
            "13": 42,
            "14": 37,
            "15": 37,
            "16": 40,
            "17": 43,
            "18": 34,
            "19": 37,
            "20": 37,
            "21": 42,
            "22": 35,
            "23": 32,
            "07": 24,
            "08": 36,
            "09": 34
          }
        },
        {
          "HwId": "T8",
          "Label": "T C230-päästöuuni P6/7",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 33,
            "11": 7,
            "12": 141,
            "13": 136,
            "14": 55,
            "15": 3,
            "16": 0,
            "17": 0,
            "18": 4,
            "19": 13,
            "20": 10,
            "21": 11,
            "22": 10,
            "23": 135,
            "07": 147,
            "08": 171,
            "09": 49
          }
        },
        {
          "HwId": "T9",
          "Label": "T Vesilaitos",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 10,
            "11": 10,
            "12": 11,
            "13": 10,
            "14": 11,
            "15": 11,
            "16": 10,
            "17": 11,
            "18": 11,
            "19": 11,
            "20": 10,
            "21": 11,
            "22": 11,
            "23": 11,
            "07": 6,
            "08": 11,
            "09": 11
          }
        }
      ],
      "Pieksämäki": [
        {
          "HwId": "P1",
          "Label": "P Ipsen T13",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 30,
            "11": 30,
            "12": 30,
            "13": 30,
            "14": 30,
            "15": 30,
            "16": 30,
            "17": 29,
            "18": 30,
            "19": 30,
            "20": 30,
            "21": 30,
            "22": 30,
            "23": 30,
            "00": 30,
            "01": 30,
            "02": 30,
            "03": 30,
            "04": 30,
            "05": 30,
            "06": 30,
            "07": 30,
            "08": 30,
            "09": 30
          }
        },
        {
          "HwId": "P10",
          "Label": "P Kaminski",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 26,
            "11": 8,
            "12": 0,
            "13": 0,
            "14": 1,
            "15": 0,
            "16": 1,
            "17": 0,
            "18": 1,
            "19": 0,
            "20": 0,
            "21": 1,
            "22": 0,
            "23": 1,
            "00": 46,
            "01": 40,
            "02": 35,
            "03": 52,
            "04": 45,
            "05": 31,
            "06": 19,
            "07": 41,
            "08": 135,
            "09": 51
          }
        },
        {
          "HwId": "P11",
          "Label": "P Sarlin-kammionitrausuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "P12",
          "Label": "P Nitrauksen pesukone",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 21,
            "11": 29,
            "12": 0,
            "13": 18,
            "14": 28,
            "15": 14,
            "16": 11,
            "17": 8,
            "18": 19,
            "19": 19,
            "20": 20,
            "21": 3,
            "22": 10,
            "23": 11,
            "00": 19,
            "01": 19,
            "02": 8,
            "03": 12,
            "04": 20,
            "05": 24,
            "06": 21,
            "07": 14,
            "08": 15,
            "09": 29
          }
        },
        {
          "HwId": "P13",
          "Label": "P Borel-kuoppauuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 120,
            "11": 48,
            "12": 33,
            "13": 98,
            "14": 90,
            "15": 35,
            "16": 36,
            "17": 8,
            "18": 1,
            "19": 1,
            "20": 1,
            "21": 1,
            "22": 1,
            "23": 1,
            "00": 1,
            "01": 22,
            "02": 1,
            "03": 15,
            "04": 123,
            "05": 77,
            "06": 133,
            "07": 62,
            "08": 36,
            "09": 56
          }
        },
        {
          "HwId": "P14",
          "Label": "P Kuoppanitrausuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 32,
            "19": 37,
            "20": 34,
            "21": 20,
            "22": 42,
            "23": 43,
            "00": 20,
            "01": 5,
            "02": 11,
            "03": 16,
            "04": 4,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "P15",
          "Label": "P Iso kuoppapäästöuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 22,
            "11": 9,
            "12": 5,
            "13": 20,
            "14": 11,
            "15": 7,
            "16": 4,
            "17": 10,
            "18": 16,
            "19": 8,
            "20": 6,
            "21": 1,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 14
          }
        },
        {
          "HwId": "P16",
          "Label": "P Päästöuuni 'Iso B'",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "P18",
          "Label": "P Ufo",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "P2",
          "Label": "P Ipsen T17",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 67,
            "11": 42,
            "12": 40,
            "13": 80,
            "14": 128,
            "15": 95,
            "16": 53,
            "17": 50,
            "18": 47,
            "19": 10,
            "20": 28,
            "21": 129,
            "22": 80,
            "23": 51,
            "00": 111,
            "01": 91,
            "02": 54,
            "03": 50,
            "04": 48,
            "05": 48,
            "06": 45,
            "07": 22,
            "08": 2,
            "09": 56
          }
        },
        {
          "HwId": "P20",
          "Label": "P Ipsen T17_1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 38,
            "11": 137,
            "12": 61,
            "13": 45,
            "14": 42,
            "15": 29,
            "16": 0,
            "17": 48,
            "18": 38,
            "19": 113,
            "20": 40,
            "21": 48,
            "22": 38,
            "23": 107,
            "00": 33,
            "01": 41,
            "02": 38,
            "03": 37,
            "04": 99,
            "05": 94,
            "06": 45,
            "07": 42,
            "08": 40,
            "09": 1
          }
        },
        {
          "HwId": "P3",
          "Label": "P Heattec 1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 8,
            "11": 18,
            "12": 8,
            "13": 8,
            "14": 15,
            "15": 9,
            "16": 8,
            "17": 8,
            "18": 8,
            "19": 20,
            "20": 8,
            "21": 8,
            "22": 8,
            "23": 23,
            "00": 8,
            "01": 11,
            "02": 18,
            "03": 8,
            "04": 8,
            "05": 24,
            "06": 9,
            "07": 8,
            "08": 8,
            "09": 8
          }
        },
        {
          "HwId": "P4",
          "Label": "P Heattec 2",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 31,
            "11": 64,
            "12": 39,
            "13": 24,
            "14": 63,
            "15": 25,
            "16": 20,
            "17": 20,
            "18": 20,
            "19": 53,
            "20": 34,
            "21": 20,
            "22": 20,
            "23": 20,
            "00": 50,
            "01": 24,
            "02": 20,
            "03": 20,
            "04": 20,
            "05": 20,
            "06": 19,
            "07": 20,
            "08": 20,
            "09": 20
          }
        },
        {
          "HwId": "P5",
          "Label": "P Heattec 3",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 14,
            "11": 13,
            "12": 14,
            "13": 13,
            "14": 51,
            "15": 32,
            "16": 14,
            "17": 13,
            "18": 13,
            "19": 13,
            "20": 14,
            "21": 13,
            "22": 13,
            "23": 47,
            "00": 13,
            "01": 18,
            "02": 59,
            "03": 18,
            "04": 14,
            "05": 13,
            "06": 13,
            "07": 29,
            "08": 52,
            "09": 15
          }
        },
        {
          "HwId": "P6",
          "Label": "P Heattec 4",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 8,
            "11": 8,
            "12": 18,
            "13": 11,
            "14": 9,
            "15": 8,
            "16": 8,
            "17": 8,
            "18": 8,
            "19": 8,
            "20": 8,
            "21": 7,
            "22": 20,
            "23": 13,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 1,
            "04": 0,
            "05": 7,
            "06": 15,
            "07": 8,
            "08": 8,
            "09": 8
          }
        },
        {
          "HwId": "P7",
          "Label": "P Automaattilinjan pesukone",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 24,
            "11": 26,
            "12": 24,
            "13": 10,
            "14": 17,
            "15": 9,
            "16": 8,
            "17": 5,
            "18": 5,
            "19": 17,
            "20": 7,
            "21": 6,
            "22": 19,
            "23": 17,
            "00": 5,
            "01": 15,
            "02": 17,
            "03": 11,
            "04": 8,
            "05": 8,
            "06": 5,
            "07": 5,
            "08": 4,
            "09": 5
          }
        },
        {
          "HwId": "P8",
          "Label": "P Kompressori",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 1,
            "11": 1,
            "12": 0,
            "13": 1,
            "14": 1,
            "15": 0,
            "16": 1,
            "17": 1,
            "18": 0,
            "19": 1,
            "20": 1,
            "21": 1,
            "22": 0,
            "23": 1,
            "00": 1,
            "01": 1,
            "02": 0,
            "03": 1,
            "04": 1,
            "05": 0,
            "06": 1,
            "07": 1,
            "08": 1,
            "09": 0
          }
        },
        {
          "HwId": "P9",
          "Label": "P Jäähdytysjärjestelmä",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 8,
            "11": 9,
            "12": 7,
            "13": 8,
            "14": 6,
            "15": 6,
            "16": 6,
            "17": 7,
            "18": 8,
            "19": 7,
            "20": 6,
            "21": 10,
            "22": 9,
            "23": 6,
            "00": 9,
            "01": 10,
            "02": 8,
            "03": 6,
            "04": 8,
            "05": 6,
            "06": 7,
            "07": 6,
            "08": 6,
            "09": 8
          }
        }
      ]
    }
  },
  {
    "ReportTimeStamp": "2026-01-20 00:01:15.756280",
    "ReportDate": "2026-01-19",
    "ReportName": "DayHeatMap",
    "Header": "ReportMessage",
    "CustomerId": "c16084",
    "DeviceId": "os-edge-unit-mini-3",
    "SubReports": {
      "Vantaa": [
        {
          "HwId": "V1",
          "Label": "V Aichelin VKEs kammiouuni 1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 29,
            "11": 86,
            "12": 45,
            "13": 42,
            "14": 64,
            "15": 60,
            "16": 29,
            "17": 61,
            "18": 40,
            "19": 41,
            "20": 66,
            "21": 24,
            "22": 30,
            "23": 63,
            "00": 26,
            "01": 28,
            "02": 22,
            "03": 29,
            "04": 25,
            "05": 26,
            "06": 18,
            "07": 44,
            "08": 41,
            "09": 26
          }
        },
        {
          "HwId": "V10",
          "Label": "V Rübig-plasma",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V11",
          "Label": "V B.M.I-alipaineuuni 52",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 1,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 1,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V12",
          "Label": "V B.M.I-alipainepäästöuuni 55",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 3,
            "11": 4,
            "12": 3,
            "13": 4,
            "14": 3,
            "15": 20,
            "16": 22,
            "17": 14,
            "18": 10,
            "19": 6,
            "20": 28,
            "21": 12,
            "22": 11,
            "23": 6,
            "00": 3,
            "01": 4,
            "02": 3,
            "03": 4,
            "04": 3,
            "05": 4,
            "06": 3,
            "07": 4,
            "08": 3,
            "09": 4
          }
        },
        {
          "HwId": "V13",
          "Label": "V Kuoppanitraus",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 33,
            "11": 20,
            "12": 1,
            "13": 2,
            "14": 2,
            "15": 2,
            "16": 2,
            "17": 2,
            "18": 1,
            "19": 2,
            "20": 2,
            "21": 2,
            "22": 2,
            "23": 2,
            "00": 2,
            "01": 2,
            "02": 2,
            "03": 2,
            "04": 2,
            "05": 0,
            "06": 31,
            "07": 65,
            "08": 46,
            "09": 43
          }
        },
        {
          "HwId": "V14",
          "Label": "V B.M.I-jäähdytysjärjestelmä",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V15",
          "Label": "V Päästö/esikuumennusuuni 36",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 17,
            "16": 7,
            "17": 4,
            "18": 2,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V16",
          "Label": "V Pesukone 37",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V17",
          "Label": "V Ipsen T2 38",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 27,
            "11": 22,
            "12": 25,
            "13": 23,
            "14": 26,
            "15": 23,
            "16": 24,
            "17": 19,
            "18": 18,
            "19": 18,
            "20": 18,
            "21": 17,
            "22": 17,
            "23": 18,
            "00": 16,
            "01": 16,
            "02": 16,
            "03": 16,
            "04": 16,
            "05": 16,
            "06": 16,
            "07": 16,
            "08": 16,
            "09": 16
          }
        },
        {
          "HwId": "V18",
          "Label": "V JK1.1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 4,
            "11": 5,
            "12": 4,
            "13": 5,
            "14": 6,
            "15": 4,
            "16": 5,
            "17": 5,
            "18": 5,
            "19": 5,
            "20": 5,
            "21": 5,
            "22": 5,
            "23": 5,
            "00": 5,
            "01": 5,
            "02": 6,
            "03": 5,
            "04": 5,
            "05": 5,
            "06": 5,
            "07": 4,
            "08": 5,
            "09": 5
          }
        },
        {
          "HwId": "V19",
          "Label": "V Etappiallas 39",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V2",
          "Label": "V Aichelin VKEs kammiouuni 2",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 37,
            "11": 69,
            "12": 67,
            "13": 35,
            "14": 35,
            "15": 52,
            "16": 39,
            "17": 39,
            "18": 101,
            "19": 61,
            "20": 38,
            "21": 54,
            "22": 35,
            "23": 117,
            "00": 37,
            "01": 35,
            "02": 39,
            "03": 36,
            "04": 38,
            "05": 27,
            "06": 28,
            "07": 31,
            "08": 36,
            "09": 36
          }
        },
        {
          "HwId": "V27",
          "Label": "V Tuloilman lämmitys",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V28",
          "Label": "V RK1.1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 7,
            "11": 6,
            "12": 5,
            "13": 5,
            "14": 3,
            "15": 3,
            "16": 4,
            "17": 3,
            "18": 4,
            "19": 3,
            "20": 4,
            "21": 3,
            "22": 4,
            "23": 3,
            "00": 3,
            "01": 3,
            "02": 3,
            "03": 3,
            "04": 4,
            "05": 4,
            "06": 5,
            "07": 7,
            "08": 4,
            "09": 7
          }
        },
        {
          "HwId": "V3",
          "Label": "V Aichelin VKEs kammiouuni 3",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 44,
            "11": 58,
            "12": 113,
            "13": 60,
            "14": 46,
            "15": 51,
            "16": 43,
            "17": 110,
            "18": 81,
            "19": 45,
            "20": 59,
            "21": 41,
            "22": 46,
            "23": 49,
            "00": 44,
            "01": 47,
            "02": 47,
            "03": 43,
            "04": 48,
            "05": 45,
            "06": 49,
            "07": 43,
            "08": 43,
            "09": 48
          }
        },
        {
          "HwId": "V30",
          "Label": "EMpro MA370",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V4",
          "Label": "V Nitrausuuni KREs 20",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 1,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 1,
            "17": 29,
            "18": 99,
            "19": 58,
            "20": 100,
            "21": 88,
            "22": 57,
            "23": 56,
            "00": 1,
            "01": 0,
            "02": 1,
            "03": 0,
            "04": 1,
            "05": 0,
            "06": 0,
            "07": 1,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V5",
          "Label": "V Alipainepesukone 21",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 9,
            "11": 8,
            "12": 9,
            "13": 10,
            "14": 8,
            "15": 9,
            "16": 14,
            "17": 28,
            "18": 13,
            "19": 10,
            "20": 5,
            "21": 7,
            "22": 6,
            "23": 7,
            "00": 6,
            "01": 8,
            "02": 9,
            "03": 11,
            "04": 10,
            "05": 12,
            "06": 11,
            "07": 9,
            "08": 5,
            "09": 8
          }
        },
        {
          "HwId": "V6",
          "Label": "V Ipsen Kammiopäästö 53",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "V7",
          "Label": "V Avoin jäähdytysjärjestelmä",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 1,
            "11": 0,
            "12": 1,
            "13": 0,
            "14": 1,
            "15": 0,
            "16": 1,
            "17": 1,
            "18": 0,
            "19": 1,
            "20": 1,
            "21": 1,
            "22": 1,
            "23": 1,
            "00": 0,
            "01": 1,
            "02": 1,
            "03": 0,
            "04": 1,
            "05": 0,
            "06": 0,
            "07": 1,
            "08": 0,
            "09": 1
          }
        },
        {
          "HwId": "V8",
          "Label": "V Päästöuuni VKHLE 28",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 13,
            "11": 31,
            "12": 61,
            "13": 12,
            "14": 12,
            "15": 12,
            "16": 21,
            "17": 40,
            "18": 12,
            "19": 12,
            "20": 70,
            "21": 12,
            "22": 12,
            "23": 12,
            "00": 2,
            "01": 3,
            "02": 3,
            "03": 3,
            "04": 3,
            "05": 3,
            "06": 3,
            "07": 48,
            "08": 70,
            "09": 27
          }
        },
        {
          "HwId": "V9",
          "Label": "V Päästöuuni VKHLE 29",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 13,
            "11": 11,
            "12": 61,
            "13": 14,
            "14": 44,
            "15": 41,
            "16": 13,
            "17": 26,
            "18": 61,
            "19": 19,
            "20": 12,
            "21": 12,
            "22": 10,
            "23": 5,
            "00": 3,
            "01": 2,
            "02": 3,
            "03": 3,
            "04": 3,
            "05": 2,
            "06": 3,
            "07": 66,
            "08": 50,
            "09": 15
          }
        }
      ],
      "Tampere": [
        {
          "HwId": "T1",
          "Label": "T C230-päästöuuni P6/1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 21,
            "11": 15,
            "12": 14,
            "13": 8,
            "14": 58,
            "15": 16,
            "16": 11,
            "17": 3,
            "18": 0,
            "19": 149,
            "20": 82,
            "21": 39,
            "22": 23,
            "23": 16,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 1,
            "06": 0,
            "07": 97,
            "08": 88,
            "09": 36
          }
        },
        {
          "HwId": "T10",
          "Label": "T Codere 230-rekuperaattori 1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 13,
            "11": 14,
            "12": 15,
            "13": 11,
            "14": 14,
            "15": 15,
            "16": 14,
            "17": 12,
            "18": 13,
            "19": 15,
            "20": 14,
            "21": 12,
            "22": 13,
            "23": 13,
            "00": 11,
            "01": 13,
            "02": 14,
            "03": 14,
            "04": 11,
            "05": 12,
            "06": 14,
            "07": 14,
            "08": 12,
            "09": 11
          }
        },
        {
          "HwId": "T12",
          "Label": "T Kuoppanitrausuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 2,
            "11": 1,
            "12": 2,
            "13": 3,
            "14": 89,
            "15": 89,
            "16": 40,
            "17": 31,
            "18": 20,
            "19": 17,
            "20": 17,
            "21": 16,
            "22": 15,
            "23": 14,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 2
          }
        },
        {
          "HwId": "T13",
          "Label": "T Nitrauksen pesukone",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 7,
            "11": 5,
            "12": 4,
            "13": 5,
            "14": 3,
            "15": 5,
            "16": 4,
            "17": 4,
            "18": 4,
            "19": 4,
            "20": 4,
            "21": 4,
            "22": 5,
            "23": 3,
            "00": 4,
            "01": 3,
            "02": 5,
            "03": 3,
            "04": 13,
            "05": 5,
            "06": 14,
            "07": 14,
            "08": 12,
            "09": 10
          }
        },
        {
          "HwId": "T14",
          "Label": "T Codere 250 päästöuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 3,
            "11": 3,
            "12": 26,
            "13": 59,
            "14": 27,
            "15": 7,
            "16": 2,
            "17": 1,
            "18": 45,
            "19": 31,
            "20": 19,
            "21": 7,
            "22": 2,
            "23": 1,
            "00": 2,
            "01": 2,
            "02": 3,
            "03": 2,
            "04": 2,
            "05": 3,
            "06": 2,
            "07": 3,
            "08": 3,
            "09": 2
          }
        },
        {
          "HwId": "T15",
          "Label": "T Codere 250 pesukone",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 16,
            "11": 6,
            "12": 3,
            "13": 5,
            "14": 4,
            "15": 4,
            "16": 4,
            "17": 3,
            "18": 4,
            "19": 3,
            "20": 4,
            "21": 4,
            "22": 4,
            "23": 3,
            "00": 4,
            "01": 5,
            "02": 4,
            "03": 4,
            "04": 3,
            "05": 12,
            "06": 4,
            "07": 4,
            "08": 6,
            "09": 5
          }
        },
        {
          "HwId": "T16",
          "Label": "T Codere 250 suola-allas",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 97,
            "11": 62,
            "12": 125,
            "13": 74,
            "14": 71,
            "15": 71,
            "16": 64,
            "17": 71,
            "18": 62,
            "19": 73,
            "20": 68,
            "21": 36,
            "22": 40,
            "23": 71,
            "00": 68,
            "01": 67,
            "02": 62,
            "03": 97,
            "04": 65,
            "05": 62,
            "06": 70,
            "07": 124,
            "08": 69,
            "09": 29
          }
        },
        {
          "HwId": "T17",
          "Label": "T Codere 250 rekuperaattori",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 20,
            "11": 21,
            "12": 20,
            "13": 19,
            "14": 19,
            "15": 20,
            "16": 20,
            "17": 20,
            "18": 20,
            "19": 20,
            "20": 20,
            "21": 20,
            "22": 20,
            "23": 20,
            "00": 20,
            "01": 20,
            "02": 20,
            "03": 20,
            "04": 20,
            "05": 20,
            "06": 18,
            "07": 20,
            "08": 20,
            "09": 20
          }
        },
        {
          "HwId": "T18",
          "Label": "T Codere 250 C10-uuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 41,
            "11": 41,
            "12": 43,
            "13": 40,
            "14": 41,
            "15": 122,
            "16": 120,
            "17": 45,
            "18": 38,
            "19": 39,
            "20": 37,
            "21": 107,
            "22": 91,
            "23": 41,
            "00": 42,
            "01": 41,
            "02": 42,
            "03": 41,
            "04": 41,
            "05": 42,
            "06": 41,
            "07": 41,
            "08": 42,
            "09": 42
          }
        },
        {
          "HwId": "T19",
          "Label": "T Kompressori (pieni)",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "T2",
          "Label": "T C230-öljypesukone LA2H",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 18,
            "11": 16,
            "12": 16,
            "13": 10,
            "14": 15,
            "15": 11,
            "16": 12,
            "17": 13,
            "18": 6,
            "19": 3,
            "20": 4,
            "21": 3,
            "22": 3,
            "23": 3,
            "00": 4,
            "01": 5,
            "02": 5,
            "03": 5,
            "04": 9,
            "05": 19,
            "06": 31,
            "07": 23,
            "08": 28,
            "09": 17
          }
        },
        {
          "HwId": "T20",
          "Label": "T AFC UBT1-päästöuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 5,
            "11": 5,
            "12": 18,
            "13": 6,
            "14": 5,
            "15": 6,
            "16": 5,
            "17": 5,
            "18": 16,
            "19": 64,
            "20": 23,
            "21": 14,
            "22": 12,
            "23": 3,
            "00": 12,
            "01": 13,
            "02": 12,
            "03": 12,
            "04": 8,
            "05": 3,
            "06": 21,
            "07": 4,
            "08": 4,
            "09": 5
          }
        },
        {
          "HwId": "T21",
          "Label": "T Schmetz 1-alipaineuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "T22",
          "Label": "T Carrier (Schmetz)",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 8,
            "11": 8,
            "12": 7,
            "13": 7,
            "14": 8,
            "15": 19,
            "16": 24,
            "17": 23,
            "18": 18,
            "19": 12,
            "20": 9,
            "21": 11,
            "22": 8,
            "23": 8,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 8,
            "08": 19,
            "09": 13
          }
        },
        {
          "HwId": "T23",
          "Label": "T Schmetz-jäähdytys",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 7,
            "11": 7,
            "12": 7,
            "13": 7,
            "14": 7,
            "15": 15,
            "16": 18,
            "17": 7,
            "18": 7,
            "19": 7,
            "20": 13,
            "21": 18,
            "22": 8,
            "23": 7,
            "00": 5,
            "01": 4,
            "02": 4,
            "03": 5,
            "04": 4,
            "05": 4,
            "06": 4,
            "07": 6,
            "08": 11,
            "09": 7
          }
        },
        {
          "HwId": "T24",
          "Label": "T AFC UBQ2-kammiouuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 55,
            "11": 48,
            "12": 103,
            "13": 166,
            "14": 106,
            "15": 69,
            "16": 60,
            "17": 58,
            "18": 57,
            "19": 56,
            "20": 55,
            "21": 55,
            "22": 54,
            "23": 54,
            "00": 56,
            "01": 52,
            "02": 24,
            "03": 47,
            "04": 95,
            "05": 114,
            "06": 61,
            "07": 48,
            "08": 108,
            "09": 123
          }
        },
        {
          "HwId": "T25",
          "Label": "T AFC UBT3-päästöuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 25,
            "11": 56,
            "12": 33,
            "13": 16,
            "14": 13,
            "15": 66,
            "16": 49,
            "17": 9,
            "18": 80,
            "19": 33,
            "20": 19,
            "21": 15,
            "22": 14,
            "23": 14,
            "00": 15,
            "01": 14,
            "02": 15,
            "03": 14,
            "04": 13,
            "05": 68,
            "06": 53,
            "07": 20,
            "08": 27,
            "09": 74
          }
        },
        {
          "HwId": "T26",
          "Label": "T Schmetz 2-alipaineuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 85,
            "11": 80,
            "12": 88,
            "13": 81,
            "14": 96,
            "15": 89,
            "16": 99,
            "17": 33,
            "18": 14,
            "19": 12,
            "20": 28,
            "21": 44,
            "22": 41,
            "23": 14,
            "00": 1,
            "01": 0,
            "02": 0,
            "03": 1,
            "04": 1,
            "05": 119,
            "06": 44,
            "07": 38,
            "08": 37,
            "09": 136
          }
        },
        {
          "HwId": "T27",
          "Label": "T Heattec 2 (Sarlin 2-päästö)",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 4,
            "01": 3,
            "02": 4,
            "03": 4,
            "04": 2,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "T28",
          "Label": "T AFC UB2T-päästöuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 64,
            "11": 40,
            "12": 16,
            "13": 9,
            "14": 46,
            "15": 65,
            "16": 46,
            "17": 21,
            "18": 17,
            "19": 12,
            "20": 4,
            "21": 3,
            "22": 4,
            "23": 4,
            "00": 6,
            "01": 5,
            "02": 5,
            "03": 5,
            "04": 5,
            "05": 28,
            "06": 9,
            "07": 6,
            "08": 12,
            "09": 43
          }
        },
        {
          "HwId": "T29",
          "Label": "T AFC UBW-pesukone",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "T3",
          "Label": "T C230-hiiletysuuni P10/9",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 76,
            "11": 77,
            "12": 55,
            "13": 115,
            "14": 142,
            "15": 191,
            "16": 225,
            "17": 263,
            "18": 290,
            "19": 233,
            "20": 123,
            "21": 96,
            "22": 91,
            "23": 79,
            "00": 57,
            "01": 61,
            "02": 64,
            "03": 65,
            "04": 63,
            "05": 206,
            "06": 222,
            "07": 98,
            "08": 82,
            "09": 79
          }
        },
        {
          "HwId": "T30",
          "Label": "T Heattec 1 (Sarlin 1-päästö)",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "T31",
          "Label": "T AFC UBQ1-kammiouuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 72,
            "11": 159,
            "12": 73,
            "13": 55,
            "14": 45,
            "15": 118,
            "16": 55,
            "17": 114,
            "18": 83,
            "19": 105,
            "20": 69,
            "21": 61,
            "22": 59,
            "23": 57,
            "00": 79,
            "01": 63,
            "02": 59,
            "03": 58,
            "04": 60,
            "05": 128,
            "06": 60,
            "07": 58,
            "08": 57,
            "09": 30
          }
        },
        {
          "HwId": "T32",
          "Label": "T Kompressori (suuri)",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 24,
            "11": 25,
            "12": 28,
            "13": 28,
            "14": 28,
            "15": 26,
            "16": 31,
            "17": 28,
            "18": 28,
            "19": 23,
            "20": 23,
            "21": 23,
            "22": 23,
            "23": 23,
            "00": 22,
            "01": 22,
            "02": 23,
            "03": 22,
            "04": 25,
            "05": 27,
            "06": 24,
            "07": 24,
            "08": 23,
            "09": 25
          }
        },
        {
          "HwId": "T33",
          "Label": "T Heattec 3",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 24,
            "11": 25,
            "12": 28,
            "13": 28,
            "14": 28,
            "15": 26,
            "16": 31,
            "17": 28,
            "18": 28,
            "19": 23,
            "20": 23,
            "21": 23,
            "22": 23,
            "23": 23,
            "00": 22,
            "01": 22,
            "02": 23,
            "03": 22,
            "04": 25,
            "05": 27,
            "06": 24,
            "07": 24,
            "08": 23,
            "09": 25
          }
        },
        {
          "HwId": "T34",
          "Label": "T Aicheling-päästö",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 24,
            "11": 25,
            "12": 28,
            "13": 28,
            "14": 28,
            "15": 26,
            "16": 31,
            "17": 28,
            "18": 28,
            "19": 23,
            "20": 23,
            "21": 23,
            "22": 23,
            "23": 23,
            "00": 22,
            "01": 22,
            "02": 22,
            "03": 22,
            "04": 25,
            "05": 27,
            "06": 24,
            "07": 24,
            "08": 24,
            "09": 25
          }
        },
        {
          "HwId": "T4",
          "Label": "T C230-öljyallas H1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 3,
            "11": 8,
            "12": 35,
            "13": 7,
            "14": 3,
            "15": 3,
            "16": 3,
            "17": 3,
            "18": 4,
            "19": 23,
            "20": 23,
            "21": 24,
            "22": 23,
            "23": 21,
            "00": 3,
            "01": 3,
            "02": 3,
            "03": 3,
            "04": 29,
            "05": 52,
            "06": 19,
            "07": 3,
            "08": 2,
            "09": 3
          }
        },
        {
          "HwId": "T5",
          "Label": "T C230-hiiletysuuni P10/10",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 104,
            "11": 78,
            "12": 48,
            "13": 82,
            "14": 47,
            "15": 53,
            "16": 150,
            "17": 98,
            "18": 219,
            "19": 266,
            "20": 143,
            "21": 100,
            "22": 90,
            "23": 76,
            "00": 2,
            "01": 2,
            "02": 3,
            "03": 2,
            "04": 2,
            "05": 2,
            "06": 2,
            "07": 3,
            "08": 2,
            "09": 24
          }
        },
        {
          "HwId": "T6",
          "Label": "T C230-suola-allas S4",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 50,
            "11": 48,
            "12": 57,
            "13": 53,
            "14": 49,
            "15": 47,
            "16": 53,
            "17": 49,
            "18": 48,
            "19": 47,
            "20": 54,
            "21": 50,
            "22": 52,
            "23": 43,
            "00": 49,
            "01": 47,
            "02": 48,
            "03": 47,
            "04": 48,
            "05": 56,
            "06": 46,
            "07": 49,
            "08": 48,
            "09": 51
          }
        },
        {
          "HwId": "T7",
          "Label": "T C230-suolapesukone LA3S",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 35,
            "11": 42,
            "12": 32,
            "13": 41,
            "14": 43,
            "15": 45,
            "16": 41,
            "17": 39,
            "18": 33,
            "19": 38,
            "20": 42,
            "21": 38,
            "22": 33,
            "23": 34,
            "00": 33,
            "01": 31,
            "02": 40,
            "03": 38,
            "04": 38,
            "05": 30,
            "06": 41,
            "07": 39,
            "08": 38,
            "09": 33
          }
        },
        {
          "HwId": "T8",
          "Label": "T C230-päästöuuni P6/7",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 101,
            "11": 73,
            "12": 75,
            "13": 185,
            "14": 65,
            "15": 28,
            "16": 1,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 58,
            "01": 34,
            "02": 30,
            "03": 29,
            "04": 9,
            "05": 0,
            "06": 0,
            "07": 71,
            "08": 261,
            "09": 185
          }
        },
        {
          "HwId": "T9",
          "Label": "T Vesilaitos",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 10,
            "11": 11,
            "12": 11,
            "13": 11,
            "14": 10,
            "15": 10,
            "16": 11,
            "17": 11,
            "18": 11,
            "19": 11,
            "20": 11,
            "21": 11,
            "22": 11,
            "23": 10,
            "00": 11,
            "01": 11,
            "02": 10,
            "03": 11,
            "04": 11,
            "05": 10,
            "06": 10,
            "07": 11,
            "08": 10,
            "09": 11
          }
        }
      ],
      "Pieksämäki": [
        {
          "HwId": "P1",
          "Label": "P Ipsen T13",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 30,
            "11": 31,
            "12": 30,
            "13": 30,
            "14": 30,
            "15": 31,
            "16": 30,
            "17": 30,
            "18": 31,
            "19": 30,
            "20": 30,
            "21": 30,
            "22": 30,
            "23": 30,
            "00": 30,
            "01": 30,
            "02": 30,
            "03": 30,
            "04": 31,
            "05": 30,
            "06": 30,
            "07": 30,
            "08": 31,
            "09": 30
          }
        },
        {
          "HwId": "P10",
          "Label": "P Kaminski",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 1,
            "12": 0,
            "13": 5,
            "14": 138,
            "15": 90,
            "16": 33,
            "17": 24,
            "18": 87,
            "19": 117,
            "20": 67,
            "21": 50,
            "22": 47,
            "23": 47,
            "00": 2,
            "01": 0,
            "02": 1,
            "03": 1,
            "04": 1,
            "05": 0,
            "06": 1,
            "07": 0,
            "08": 1,
            "09": 0
          }
        },
        {
          "HwId": "P11",
          "Label": "P Sarlin-kammionitrausuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "P12",
          "Label": "P Nitrauksen pesukone",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 14,
            "11": 25,
            "12": 26,
            "13": 15,
            "14": 17,
            "15": 15,
            "16": 21,
            "17": 11,
            "18": 24,
            "19": 23,
            "20": 15,
            "21": 11,
            "22": 11,
            "23": 10,
            "00": 14,
            "01": 11,
            "02": 12,
            "03": 10,
            "04": 30,
            "05": 32,
            "06": 24,
            "07": 15,
            "08": 10,
            "09": 20
          }
        },
        {
          "HwId": "P13",
          "Label": "P Borel-kuoppauuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 58,
            "11": 115,
            "12": 87,
            "13": 38,
            "14": 34,
            "15": 1,
            "16": 1,
            "17": 1,
            "18": 1,
            "19": 1,
            "20": 1,
            "21": 1,
            "22": 1,
            "23": 1,
            "00": 1,
            "01": 2,
            "02": 1,
            "03": 1,
            "04": 89,
            "05": 123,
            "06": 123,
            "07": 136,
            "08": 109,
            "09": 59
          }
        },
        {
          "HwId": "P14",
          "Label": "P Kuoppanitrausuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 29,
            "17": 39,
            "18": 21,
            "19": 41,
            "20": 48,
            "21": 34,
            "22": 25,
            "23": 21,
            "00": 9,
            "01": 16,
            "02": 15,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "P15",
          "Label": "P Iso kuoppapäästöuuni",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 35,
            "12": 12,
            "13": 7,
            "14": 4,
            "15": 25,
            "16": 10,
            "17": 7,
            "18": 4,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "P16",
          "Label": "P Päästöuuni 'Iso B'",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "P18",
          "Label": "P Ufo",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "P2",
          "Label": "P Ipsen T17",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 75,
            "11": 120,
            "12": 54,
            "13": 48,
            "14": 46,
            "15": 23,
            "16": 7,
            "17": 117,
            "18": 101,
            "19": 53,
            "20": 48,
            "21": 47,
            "22": 26,
            "23": 6,
            "00": 41,
            "01": 42,
            "02": 41,
            "03": 42,
            "04": 42,
            "05": 41,
            "06": 41,
            "07": 42,
            "08": 42,
            "09": 42
          }
        },
        {
          "HwId": "P20",
          "Label": "P Ipsen T17_1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 44,
            "11": 135,
            "12": 99,
            "13": 46,
            "14": 42,
            "15": 41,
            "16": 3,
            "17": 10,
            "18": 129,
            "19": 85,
            "20": 45,
            "21": 42,
            "22": 40,
            "23": 0,
            "00": 37,
            "01": 38,
            "02": 37,
            "03": 37,
            "04": 38,
            "05": 37,
            "06": 37,
            "07": 37,
            "08": 37,
            "09": 38
          }
        },
        {
          "HwId": "P3",
          "Label": "P Heattec 1",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 8,
            "11": 8,
            "12": 8,
            "13": 8,
            "14": 7,
            "15": 8,
            "16": 8,
            "17": 8,
            "18": 14,
            "19": 14,
            "20": 8,
            "21": 8,
            "22": 31,
            "23": 9,
            "00": 8,
            "01": 8,
            "02": 8,
            "03": 7,
            "04": 8,
            "05": 8,
            "06": 8,
            "07": 8,
            "08": 8,
            "09": 8
          }
        },
        {
          "HwId": "P4",
          "Label": "P Heattec 2",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 21,
            "11": 21,
            "12": 20,
            "13": 22,
            "14": 64,
            "15": 32,
            "16": 21,
            "17": 54,
            "18": 28,
            "19": 20,
            "20": 20,
            "21": 20,
            "22": 20,
            "23": 20,
            "00": 20,
            "01": 20,
            "02": 20,
            "03": 20,
            "04": 20,
            "05": 20,
            "06": 20,
            "07": 22,
            "08": 64,
            "09": 30
          }
        },
        {
          "HwId": "P5",
          "Label": "P Heattec 3",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 16,
            "11": 13,
            "12": 13,
            "13": 13,
            "14": 52,
            "15": 32,
            "16": 14,
            "17": 13,
            "18": 14,
            "19": 14,
            "20": 13,
            "21": 13,
            "22": 13,
            "23": 13,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 16,
            "05": 42,
            "06": 15,
            "07": 13,
            "08": 62,
            "09": 44
          }
        },
        {
          "HwId": "P6",
          "Label": "P Heattec 4",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 0,
            "12": 1,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "00": 0,
            "01": 0,
            "02": 0,
            "03": 0,
            "04": 0,
            "05": 0,
            "06": 0,
            "07": 0,
            "08": 0,
            "09": 0
          }
        },
        {
          "HwId": "P7",
          "Label": "P Automaattilinjan pesukone",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 7,
            "11": 7,
            "12": 28,
            "13": 18,
            "14": 8,
            "15": 7,
            "16": 8,
            "17": 6,
            "18": 17,
            "19": 15,
            "20": 13,
            "21": 8,
            "22": 6,
            "23": 6,
            "00": 6,
            "01": 5,
            "02": 6,
            "03": 5,
            "04": 7,
            "05": 10,
            "06": 7,
            "07": 8,
            "08": 3,
            "09": 7
          }
        },
        {
          "HwId": "P8",
          "Label": "P Kompressori",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 0,
            "11": 1,
            "12": 1,
            "13": 0,
            "14": 1,
            "15": 1,
            "16": 0,
            "17": 1,
            "18": 1,
            "19": 1,
            "20": 0,
            "21": 1,
            "22": 1,
            "23": 0,
            "00": 0,
            "01": 1,
            "02": 1,
            "03": 0,
            "04": 1,
            "05": 1,
            "06": 1,
            "07": 0,
            "08": 1,
            "09": 1
          }
        },
        {
          "HwId": "P9",
          "Label": "P Jäähdytysjärjestelmä",
          "ValueName": "ActiveEnergy",
          "Unit": "kWh",
          "Values": {
            "10": 6,
            "11": 6,
            "12": 7,
            "13": 6,
            "14": 6,
            "15": 6,
            "16": 7,
            "17": 8,
            "18": 11,
            "19": 9,
            "20": 6,
            "21": 7,
            "22": 6,
            "23": 7,
            "00": 6,
            "01": 7,
            "02": 6,
            "03": 6,
            "04": 6,
            "05": 7,
            "06": 6,
            "07": 6,
            "08": 6,
            "09": 6
          }
        }
      ]
    }
  }
]

